export const SEARCH_DEBOUNCE_TIME = 850
export const REQUEST_DEFAULT_CANCEL_TIMEOUT = 30000
